export const IFRAME_POST_MESSAGE = {
  youtube: {
    pause: '{"event":"command","func":"pauseVideo","args":""}',
    play: '{"event":"command","func":"playVideo","args":""}',
  },
  vimeo: {
    pause: '{"method":"pause"}',
    play: '{"method":"play"}',
  },
  dailymotion: {
    pause: '{"command":"pause"}',
    play: '{"command":"play"}',
  },
};
